import * as React from 'react';

import DocInfo16 from './DocInfo16';

export const docInfo16 = () => <DocInfo16 />;

export default {
    title: 'Icon/Line/DocInfo16',
    component: DocInfo16,
    parameters: {
        notes: "`import DocInfo16 from 'box-ui-elements/es/icon/line/DocInfo16';`",
    },
};
